import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

// GET all billOfMaterialsMps
export const getBillOfMaterialsMps = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/bill-of-materials-mp`);
    return response.data;
  } catch (error) {
    console.error("Error fetching bill-of-materials-mp:", error.response?.data || error);
    throw error;
  }
};

// GET a single billOfMaterialsMp
export const getBillOfMaterialsMpById = async (id) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/bill-of-materials-mp/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching bill-of-materials-mp:", error.response?.data || error);
    throw error;
  }
};

// CREATE a new billOfMaterialsMp
export const createBillOfMaterialsMp = async (billOfMaterialsMpData) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/bill-of-materials-mp`, billOfMaterialsMpData);
    return response.data;
  } catch (error) {
    console.error("Error creating bill-of-materials-mp:", error.response?.data || error);
    throw error;
  }
};

// UPDATE an existing billOfMaterialsMp
export const updateBillOfMaterialsMp = async (id, billOfMaterialsMpData) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/bill-of-materials-mp/${id}`, billOfMaterialsMpData);
    return response.data;
  } catch (error) {
    console.error("Error updating bill-of-materials-mp:", error.response?.data || error);
    throw error;
  }
};

// DELETE a billOfMaterialsMp
export const deleteBillOfMaterialsMp = async (id) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/bill-of-materials-mp/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting bill-of-materials-mp:", error.response?.data || error);
    throw error;
  }
};

// GET billOfMaterialsMps by maintenancePlanId
export const getBillOfMaterialsMpsByMaintenancePlanId = async (maintenancePlanId) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/bill-of-materials-mp`, {      params: { maintenancePlanId },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching bill-of-materials-mp:', error.response?.data || error);
    throw error;
  }
};
